<div class="container">
    <img class="picto" [src]="qrcode">
    <div class="body">
        <span class="label">{{ "timeline.qrcode.labelShort" | translate}}</span>
        <span class="code">{{ "timeline.qrcode.code" | translate}} {{confidentialCode}}</span>
    </div>
    <div class="button" (click)="openConfidentialCode()" *ngIf="isMobile">
        <div class="button_action">{{ "button.qrcode" | translate}}</div>
    </div>
</div>
